module.exports = __webpack_public_path__ + "img/story-mode.4734bea4.svg";